import {useJsonFetch} from '@sail/data';
import type {FetchState} from '@sail/data';

import {getCryptoStandaloneUrl} from 'src/utils/buildStripeApiClient';
import type {ReturnDetailsCollectionSessionCredentials} from 'src/return/state/useReturnDetailsCollectionContext';

export const useResumeReturnDetailsCollectionSession = (
  slug: string,
): FetchState<ReturnDetailsCollectionSessionCredentials> => {
  return useJsonFetch<ReturnDetailsCollectionSessionCredentials>(
    getCryptoStandaloneUrl('/resume_return_details_collection_session'),
    {
      method: 'POST',
      body: new URLSearchParams({
        session_hash: slug,
      }).toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest',
      },
    },
  );
};
